import React, { Component } from 'react';
import { AltCheckbox } from '../../components/AltCheckbox';
import { Alert } from '../../components/Alert';
import axios from 'axios';
import InputPassword from '../../components/InputPassword';
import PropTypes from 'prop-types';
import PageClean from '../default/PageClean';
import { getPartnerOptions } from '../../actions/ActionPartnerWL';
import { getUser } from '../../actions/ActionUser';
import Select from 'react-select';
import { getCustomerOptionsList } from '../../actions/ActionCustomer';
import { can, hasFullAccess } from '../../utils/permissions';
import { getPermissionList } from '../../actions/ActionUser';

class User extends Component {
  static propTypes = {
    bIsEditing: PropTypes.bool,
    bIsModal: PropTypes.bool,
    fnHandleClose: PropTypes.func,
    fnHandleConfirm: PropTypes.func,
  };

  static defaultProps = {
    bIsEditing: false,
    bIsModal: false,
    fnHandleClose: evtHandleClose => { },
    fnHandleConfirm: evtHandleConfirm => { },
  };

  constructor(oProps) {
    super(oProps);
    this.state = {
      oAdminUser: {
        adm_cname: '',
        adm_bisactive: false,
        adm_cemail: '',
        adm_cpassword: '',
        adm_cconfirmpassword: ''
      },
      aPermissions: [],
      aPermissionsSelected: [],
      bLoading: true,
      rcmpAlertMsg: null
    };
  }

  componentDidMount() {
    const { bIsEditing, nUserId, setAlert, onClose, onUpdate } = this.props;

    const oDummyPromise = new Promise((resolve) => resolve({}));
    const aPromises = [];
    aPromises.push(getPartnerOptions());
    aPromises.push(getCustomerOptionsList());
    aPromises.push(bIsEditing ? getUser(nUserId) : oDummyPromise);
    aPromises.push(can('edit-user') ? getPermissionList() : oDummyPromise);

    Promise.all(aPromises)
      .then(([aPartners, aCustomers, oUserData, { aPermissions }]) => {
        const oNoPartnerOption = aPartners.find(p => p.value === -1); // "Acredite-se" vem como -1
        oNoPartnerOption.value = null;

        this.setState({
          aPartners,
          aCustomers,
          aCustomersFiltered: this.filterCustomersByWL(
            aCustomers,
            !bIsEditing ? null : oUserData.oAdminUser.wlpn_nid,
          ),
          ...(bIsEditing && { oAdminUser: oUserData.oAdminUser, aPermissionsSelected: oUserData.oAdminUser.aPermissions }),
          ...(can('edit-user') && { aPermissions }),
          bLoading: false,
        });
      })
      .catch((oError) => {
        this.setState({
          rcmpAlertMsg: (
            <Alert type="error" isOpen onCloseAlert={() => { }}>
              {oError.aMsgErrors}
            </Alert>
          ),
          bLoading: false,
        });
      });
  }

  /**
   * @param {Array} aCustomers
   * @param {number|null} nWlpnId
   */
  filterCustomersByWL = (aCustomers, nWlpnId = null) => {
    return (nWlpnId === null)
      ? aCustomers
      : aCustomers.filter(c => c.wlpn_nid === nWlpnId);
  }

  handleChange = (evt, cAttributeName) => {
    const { oAdminUser } = this.state;

    if (evt.target.type === 'checkbox') {
      oAdminUser[cAttributeName] = evt.target.checked;
      this.setState({
        oAdminUser
      });
      if (this.props.onUpdate) this.props.onUpdate(oAdminUser);
    } else if (evt.target.value !== null) {
      oAdminUser[cAttributeName] = evt.target.value;
      this.setState({
        oAdminUser
      });
      if (this.props.onUpdate) this.props.onUpdate(oAdminUser);
    }
  }

  userCreate = () => {
    const { history } = this.props;
    const { oAdminUser, aPermissionsSelected } = this.state;

    axios.post('/admin/store', {
      'adm_cname': oAdminUser.adm_cname,
      'adm_cemail': oAdminUser.adm_cemail,
      'adm_cpassword': oAdminUser.adm_cpassword,
      'adm_bisactive': oAdminUser.adm_bisactive,
      'wlpn_nid': oAdminUser.wlpn_nid,
      'cust_nid': oAdminUser.cust_nid,
      'aPermissions': [...new Set(aPermissionsSelected)],
    })
      .then((oResponse) => {
        history.push({
          pathname: '/User',
          state: { aAlertMessages: { cType: 'success', cMsg: 'Usuário criado com sucesso!' } }
        });
      }).catch((oError) => {
        this.setState({
          rcmpAlertMsg: (
            <Alert type="error" isOpen onCloseAlert={() => { }}>
              {oError.aMsgErrors}
            </Alert>
          )
        });
      });
  }

  userUpdate = () => {
    const { fnHandleConfirm } = this.props;
    const { oAdminUser, aPermissionsSelected } = this.state;

    axios.put('/admin/update', {
      'adm_nid': oAdminUser.adm_nid,
      'adm_cname': oAdminUser.adm_cname,
      'adm_cemail': oAdminUser.adm_cemail,
      'adm_cpassword': oAdminUser.adm_cpassword,
      'adm_bisactive': oAdminUser.adm_bisactive,
      'wlpn_nid': oAdminUser.wlpn_nid,
      'cust_nid': oAdminUser.cust_nid,
      'aPermissions': [...new Set(aPermissionsSelected)],
    })
      .then((oResponse) => {
        fnHandleConfirm('success', 'Usuário atualizado com sucesso!');
      })
      .catch((oError) => {
        this.setState({
          rcmpAlertMsg: (
            <Alert type="error" isOpen onCloseAlert={() => { }}>
              {oError.aMsgErrors}
            </Alert>
          )
        });
      });
  }

  handlePermSelect = (evt, cPerm) => {
    const { aPermissionsSelected } = this.state;

    if (evt.target.checked) {
      aPermissionsSelected.push(cPerm);
      this.setState({ aPermissionsSelected });
    } else {
      this.setState({ aPermissionsSelected: aPermissionsSelected.filter(p => p !== cPerm) });
    }
  }

  handlePermSelectAll = (evt) => {
    const { aPermissions } = this.state;

    if (evt.target.checked) {
      this.setState({ aPermissionsSelected: aPermissions.map(p => p.admp_cslug) });
    } else {
      this.setState({ aPermissionsSelected: [] });
    }
  }

  handleSubmit = (evt) => {
    evt.preventDefault();
    const { setAlert, bIsEditing } = this.props;
    const { oAdminUser } = this.state;

    if (oAdminUser.adm_cpassword !== oAdminUser.adm_cconfirmpassword && oAdminUser.adm_cpassword !== undefined) {
      setAlert('error', 'Senhas diferentes!');
    } else if (oAdminUser.adm_cpassword !== undefined && oAdminUser.adm_cpassword.length < 6) {
      setAlert('error', 'Número mínimo de caracteres deve ser maior ou igual a 6!');
    } else if (bIsEditing) {
      this.userUpdate();
    } else {
      this.userCreate();
    }

  }

  renderAdminUser = () => {
    const { oAdminUser, aPartners, aCustomersFiltered, aCustomers, aPermissionsSelected, aPermissions } = this.state;
    const { bIsEditing, fnHandleClose, history } = this.props;

    return (
      <form
        className="form"
        onSubmit={this.handleSubmit}
      >
        <input name="_token" type="hidden" value="EvqPygz3uAjVmAdnwafVRC2OEzt0Oyti8qsr1BG9" />
        <fieldset>
          <legend>Informações pessoais</legend>
          <label className="split2">
            Nome Completo
              <input maxLength="250" className="" required name="adm_cname" type="text" value={oAdminUser.adm_cname} onChange={evt => this.handleChange(evt, 'adm_cname')} />
          </label>

          <AltCheckbox
            name="adm_bisactive"
            id="adm_bisactive"
            label="Usuário Ativo"
            onChange={evt => this.handleChange(evt, 'adm_bisactive')}
            checked={oAdminUser.adm_bisactive}
          />
        </fieldset>
        <fieldset>
          <legend>Dados de acesso</legend>
          <label className="split">
            E-mail
              <input
              maxLength="250"
              className=""
              required
              name="adm_cemail"
              type="email"
              value={oAdminUser.adm_cemail || ''}
              onChange={evt => this.handleChange(evt, 'adm_cemail')}
              autoComplete="new-email"
            />
          </label>
          <div className="clearfix" />
          <label className={!bIsEditing ? "split2 password" : "password"}>
            <InputPassword
              value={oAdminUser.adm_cpassword || ''}
              inputid={"adm_cpassword"}
              inputplaceholder={"Senha"}
              inputname={"adm_cpassword"}
              onChange={evt => this.handleChange(evt, 'adm_cpassword')}
              required={!bIsEditing}
            />
          </label>

          <label className={!bIsEditing ? "split2 password" : "password"}>
            <InputPassword
              value={oAdminUser.adm_cconfirmpassword || ''}
              inputid={"adm_cconfirmpassword"}
              inputplaceholder={"Confirmar Senha"}
              inputname={"adm_cconfirmpassword"}
              onChange={evt => this.handleChange(evt, 'adm_cconfirmpassword')}
              required={!bIsEditing}
            />
          </label>

          {!!hasFullAccess() && (
            <label>
              Parceiro white label
              <Select
                className={`selectCustom`} // oClasses.partnerList
                classNamePrefix="react-select"
                noOptionsMessage={() => ''}
                placeholder="Selecione"
                options={aPartners || []}
                maxMenuHeight={190}
                defaultValue={(aPartners || []).find(p => p.value === oAdminUser.wlpn_nid) || null}
                onChange={(oOption) => {
                  if (oOption.value === oAdminUser.wlpn_nid) return;
                  oAdminUser.wlpn_nid = oOption.value;
                  const aNewCustomers = this.filterCustomersByWL(aCustomers, oAdminUser.wlpn_nid);
                  this.setState({ oAdminUser, aCustomersFiltered: aNewCustomers });
                  if (this.props.onUpdate) this.props.onUpdate(oAdminUser);
                }}
                required
              />
            </label>
          )}

          <label>
            Cliente acessado
            <Select
              className={`selectCustom`}
              classNamePrefix="react-select"
              noOptionsMessage={() => ''}
              placeholder="Selecione"
              options={aCustomersFiltered || []}
              maxMenuHeight={190}
              defaultValue={(aCustomersFiltered || []).find(p => p.value === oAdminUser.cust_nid) || null}
              onChange={(oOption) => {
                oAdminUser.cust_nid = oOption.value;
                this.setState({ oAdminUser });
                if (this.props.onUpdate) this.props.onUpdate(oAdminUser);
              }}
              required
            />
          </label>
        </fieldset>

        {can('edit-user') && (
          <fieldset>
            <legend>Permissões</legend>

            <AltCheckbox
              name="all-permissions"
              id="all-permissions"
              label="Marcar todas"
              onChange={this.handlePermSelectAll}
              checked={aPermissionsSelected.length === aPermissions.length}
              className="split1"
              style={{ paddingTop: 0, marginBottom: "60px", fontWeight: 400 }}
            />

            {aPermissions.map((oPerm) => (
              <AltCheckbox
                key={oPerm.admp_cslug}
                name={"permission-" + oPerm.admp_cslug}
                label={oPerm.admp_cname}
                onChange={(evt) => this.handlePermSelect(evt, oPerm.admp_cslug)}
                checked={aPermissionsSelected.includes(oPerm.admp_cslug)}
                style={{ paddingTop: 0}}
              />
            ))}
          </fieldset>
        )}

        <div className="button-stack">
          <button type="button" className="btn alternate back btn btn-outline-secondary" title="Cancelar" onClick={(evtClick) => {
            if (bIsEditing) {
              fnHandleClose();
            } else {
              history.push({
                pathname: '/User'
              });
            }
          }}>
            Cancelar
            </button>
          {bIsEditing ? (
            <button type="submit" value="salvar" className="btn btn btn-secondary" title="Salvar">
              Salvar
            </button>
          ) : (
            <button type="submit" value="salvar" className="btn btn btn-secondary" title="Criar">
              Criar
            </button>
          )}
        </div>

      </form>
    );
  }

  render() {
    const { bLoading, rcmpAlertMsg, aPartners } = this.state;
    const { bIsModal } = this.props;

    const nAuthUserId = +localStorage.getItem("nUserId");

    if (!can('edit-user') && (!bIsModal || nAuthUserId !== this.props.nUserId)) {
      return window.location.href = '/';
    }

    if (bIsModal) {
      return (
        <PageClean bLoading={bLoading || !aPartners ? 1 : 0}>
          {rcmpAlertMsg}
          {this.renderAdminUser()}
        </PageClean>
      );
    }
    if (!aPartners) return null;
    return (
      <>
        <main id="container" className="centered">
          <div className="clearfix" />
          {rcmpAlertMsg}
          <h1>Criar usuário</h1>
          {this.renderAdminUser()}
          <ul id="bubble-alerts" />
        </main>
      </>
    );
  }
}

export default User;
